import React from 'react';
import { useApiGet } from 'react-reqq-lite';
import { useAuth } from 'modules/auth/hooks';
import Logout from 'modules/auth/containers/Logout';
import { Link, Route, Switch } from 'react-router-dom';
import { AUTHENTICATION } from 'modules/auth/constants';
import { ModalProvider } from 'partial/components/Modal';
import ErrorBoundary from 'partial/containers/ErrorBoundary';
import EmailActivationRoutes from 'modules/auth/containers/EmailActivationRoutes';
import PrivacyPolicy from 'modules/auth/containers/PrivacyPolicy';
import TermsAndCondition from 'modules/auth/containers/TermsAndCondition';
import Private from './Private';
import Public from './Public';

export const PURGE_IGNORE = () => <input type="tel" />;

const PrivateRoutes = React.memo(() => {
  const auth = useApiGet(AUTHENTICATION, {});
  if (auth.userType === 'ADMINISTRATOR') return <Private />;
  return (
    <Switch>
      <Route path="/logout" component={Logout} />
      <Route>
        <div>
          Unknown user type.{' '}
          <Link className="text-primary-500 hover:underline" to="/logout">
            Logout
          </Link>
        </div>
      </Route>
    </Switch>
  );
});

function App() {
  const [isAppReady, isAuthenticated] = useAuth();
  if (!isAppReady) return null;
  return (
    <ErrorBoundary>
      <ModalProvider>
        <Switch>
          {/* <Route path="/p/print-sample/:doc_id" component={PrintContainer} /> */}
          <Route path="/email-activation" component={EmailActivationRoutes} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/terms-and-condition" component={TermsAndCondition} />
          <Route>
            {isAuthenticated ? (
              // <Suspense fallback={<div>Loading...</div>}>
              <PrivateRoutes />
            ) : (
              // </Suspense>
              <Public />
            )}
          </Route>
        </Switch>
      </ModalProvider>
    </ErrorBoundary>
  );
}

export default App;
